import { useUIStore } from '@/store/UIStore.ts';
import { LuTriangleAlert } from 'react-icons/lu';

export function ReportProblemButton() {
  return (
    <button
      onClick={() => useUIStore.getState().setShowSendFeedbackToplevelSidePanel(true)}
      aria-label="Report a problem"
      title="Report a problem"
      className="rounded-full hover:bg-muted flex items-center justify-center transition-colors"
    >
      <LuTriangleAlert className="h-5 w-5 text-muted-foreground" />
    </button>
  );
}
